import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../../Context/AuthContext";
import { saveAs } from "file-saver";
import { backView } from "../../../../Assets/Img/id-card-back.png";

export const EmployeeNavbar = ({ toggle, show }) => {
  const { user } = useContext(AuthContext);
  const saveFile = () => {
    saveAs("../../../../Assets/Img/id-card-back.png", "Back.png");
  };
  return (
    <div className="content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box-two">
              <h4 className="page-title"></h4>
              <h1 className="welcome_text">EMPLOYEE MANAGEMENT</h1>
              <div className="clearfix"></div>
            </div>
          </div>
        </div>

        <div>
          <nav
            className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
            style={{
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
            }}
          >
            <a href="/" className="navbar-brand d-flex w-50 mr-auto"></a>
            <ul className="navbar-nav w-100 ml-auto justify-content-center">
              <li className="nav-item ml-auto">
                <Link
                  className="nav-link"
                  to="/dashboard/employee"
                  style={{ borderRight: "3px solid #243050" }}
                >
                  EMPLOYEE
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link"
                  to="/dashboard/employee/disciplinary"
                  style={{ borderRight: "3px solid #243050" }}
                >
                  DISCIPLINARY CASE
                </Link>
              </li>
            </ul>
            <div
              className="navbar-collapse collapse w-100"
              id="collapsingNavbar3"
            >
              <ul className="nav navbar-nav ml-auto w-100 justify-content-end">
                <li className="nav-item ml-auto"></li>
              </ul>
            </div>
          </nav>
        </div>

        <div
          style={{
            boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.075)",
          }}
        >
          <nav
            className="navbar navbar-light navbar-expand-md bg-faded justify-content-center"
            style={{ backgroundColor: "#243050" }}
          >
            <ul className="navbar-nav w-100 float-left">
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownLbl"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <h4>
                    EMPLOYEES{" "}
                    <i className="fa fa-chevron-down font-13 ml-1"> </i>
                  </h4>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-right w-auto shadow p-0"
                  id="navbarDropdown"
                  aria-labelledby="navbarDropdownLbl"
                >
                  <Link
                    className="dropdown-item d-flex flex-nowrap align-items-center pt-2 px-0"
                    to="/dashboard/employee"
                  >
                    <div className="flex-shrink-1 text-center px-3">
                      <i className="ion-ios-construct-outline h1"></i>
                    </div>
                    <div className="pl-0 pr-4">Employee List</div>
                  </Link>
                  <Link
                    className="dropdown-item d-flex flex-nowrap align-items-center pt-2 px-0"
                    to="/dashboard/employee/who-is-out"
                  >
                    <div className="flex-shrink-1 text-center  px-3">
                      <i className="ion-ios-bookmarks-outline h1"></i>
                    </div>
                    <div className="pl-0 pr-4">Who's Out</div>
                  </Link>

                  {(user.data.user.roles &&
                    user.data.user.roles.name !== "employee") ||
                  user.data.user.roles.name === "line manager" ? (
                    <Link
                      className="dropdown-item d-flex flex-nowrap align-items-center pt-2 px-0"
                      to="/dashboard/employee/inactive"
                    >
                      <div className="flex-shrink-1 text-center  px-3">
                        <i className="ion-ios-jet-outline h1"></i>
                      </div>
                      <div className="pl-0 pr-4">Inactive</div>
                    </Link>
                  ) : null}

                  {(user.data.user.roles &&
                    user.data.user.roles.name !== "employee") ||
                  user.data.user.roles.name === "line manager" ? (
                    <Link
                      className="dropdown-item d-flex flex-nowrap align-items-center pt-2 px-0"
                      to="/dashboard/employee/id-card"
                    >
                      <div className="flex-shrink-1 text-center  px-3">
                        <i className="ion-ios-cube-outline h1"></i>
                      </div>
                      <div className="pl-0 pr-4">ID Cards</div>
                    </Link>
                  ) : null}

                  {(user.data.user.roles &&
                    user.data.user.roles.name !== "employee") ||
                  user.data.user.roles.name === "line manager" ? (
                    <Link
                      className="dropdown-item d-flex flex-nowrap align-items-center pt-2 px-0"
                      // to="../../../../Assets/Img/id-card-back.png"
                      // download
                      // target="_blank"
                      onClick={saveFile}
                    >
                      <div className="flex-shrink-1 text-center  px-3">
                        <i className="ion-ios-cube-outline h1"></i>
                      </div>
                      <div className="pl-0 pr-4">Back View</div>
                    </Link>
                  ) : null}
                </div>
              </li>
            </ul>

            <ul className="m-0 text-white" onClick={toggle}>
              <i className={show === true ? "fa fa-th" : "fa fa-bars"}></i>
            </ul>

            <ul className="nav navbar-nav">
              {(user.data.user.roles &&
                user.data.user.roles.name === "admin") ||
              user.data.user.roles.name === "human resource" ? (
                <li className="nav-item">
                  <Link className="nav-link" to="/dashboard/create-employee">
                    <button className="btn nt-button-color-action">
                      CREATE EMPLOYEE
                    </button>
                  </Link>
                </li>
              ) : null}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/employeemanagement/reusedcomponent/navbar.js